
import React from 'react';
import { AlertCircle } from 'lucide-react';

const UlosottoProcessSection: React.FC = () => {
  return (
    <>
      <h2>Ulosottoprosessin kulku</h2>
      <ol className="list-decimal pl-6 space-y-4 mb-8">
        <li>
          <strong>Vireillepano:</strong> Velkoja hakee ulosottoa toimittamalla ulosottohakemuksen ulosottovirastoon. 
          Hakemukseen on liitettävä ulosottoperuste, kuten tuomioistuimen päätös.
        </li>
        <li>
          <strong>Vireilletuloilmoitus:</strong> Velalliselle lähetetään vireilletuloilmoitus, jossa kerrotaan velan 
          siirtymisestä ulosottoon. Ilmoituksessa on maksukehotus, joka kannattaa ottaa vakavasti.
        </li>
        <li>
          <strong>Maksuaika:</strong> Velallisella on mahdollisuus maksaa velka kokonaisuudessaan tai sopia maksusuunnitelmasta 
          ulosottomiehen kanssa.
        </li>
        <li>
          <strong>Ulosmittaus:</strong> Jos velkaa ei makseta tai maksusuunnitelmaa ei noudateta, siirrytään ulosmittaukseen. 
          Yleisimmin ulosmittaus kohdistuu palkkatuloon, eläkkeeseen tai pankkitiliin.
        </li>
        <li>
          <strong>Tilitys:</strong> Ulosmitatut varat tilitetään velkojalle.
        </li>
      </ol>

      <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-8">
        <h3 className="text-lg font-semibold mb-3 flex items-center"><AlertCircle size={20} className="mr-2 text-yellow-600" /> Tärkeää tietää</h3>
        <p className="mb-4">
          Ulosottovirasto ei koskaan pyydä pankkitunnuksia tai salasanoja sähköpostitse tai puhelimitse. 
          Ole tarkkana huijausyritysten varalta!
        </p>
        <p>
          Ulosottomiehellä on laajat valtuudet selvittää velallisen taloudellista tilannetta, mutta 
          toimintaa säädellään tarkasti lailla.
        </p>
      </div>
    </>
  );
};

export default UlosottoProcessSection;
